import React from 'react';
import {
    Card,
    Typography,
    Grid,
    Button,
} from '@material-ui/core/';
import axios from 'axios';
import { ModalInput } from './common';

type SeasonDate = {
    beforeSeason: string;
    season: string;
    afterSeason: string;
}

type SeasonDateVariant = 'beforeSeason' | 'season' | 'afterSeason';

type PriceList = {
    outSeason: {
        text: string;
        price: string;
      },
      season: {
        text: string;
        price: string;
      },
};

type PriceListVariant = 'outSeasonText' | 'outSeasonPrice' | 'seasonText' | 'seasonPrice';

type InfoText = {
    lineOne: string;
    lineTwo: string;
    footerLine: string;
};

type InfoTextVariant = 'lineOne' | 'lineTwo' | 'footerLine';

interface EditModalProps {
    priceByDate: SeasonDate;
    setPriceByDate: React.Dispatch<React.SetStateAction<SeasonDate>>;
    priceList: PriceList;
    setPriceList: React.Dispatch<React.SetStateAction<PriceList>>;
    infoText: InfoText;
    setInfoText: React.Dispatch<React.SetStateAction<InfoText>>;
    onClose: () => void;
    priceListId: string;
    API: string;
}

function EditPriceModal( props: EditModalProps) {
    const { 
        priceByDate, 
        setPriceByDate,
        priceList,
        setPriceList,
        infoText,
        setInfoText,
        onClose,
        priceListId,
        API
    } = props;

    const updatedPriceList = {
        priceByDate,
        priceList,
        infoText,
    }

    const onSubmit = () => {
        axios.patch(`${API}priceList/${priceListId}`, updatedPriceList).catch(err => console.log('Error: ' + err));
        onClose();
    }

    const handleSeasonDateChange = (variant: SeasonDateVariant) => {
        const handleChange = (e: string) => setPriceByDate({
            beforeSeason: variant === 'beforeSeason' ? e : priceByDate.beforeSeason,
            season: variant === 'season' ? e : priceByDate.season,
            afterSeason: variant === 'afterSeason' ? e : priceByDate.afterSeason,
        });

        return handleChange
    }

    const handleOutSeasonChange = (variant: PriceListVariant) => {
        const handleChange = (e: string) => setPriceList({
            outSeason: {
                text: variant === 'outSeasonText' ? e : priceList.outSeason.text,
                price: variant === 'outSeasonPrice' ? e : priceList.outSeason.price
            },
            season: {
                text: variant === 'seasonText' ? e : priceList.season.text,
                price: variant === 'seasonPrice' ? e : priceList.season.price
            }
        });

        return handleChange
    }

    const handleInfoTextChange = (variant: InfoTextVariant) => {
        const handleChange = (e: string) => setInfoText({
            lineOne: variant === 'lineOne' ? e : infoText.lineOne,
            lineTwo: variant === 'lineTwo' ? e : infoText.lineTwo,
            footerLine: variant === 'footerLine' ? e : infoText.footerLine
        });

        return handleChange
    }

    return (
        <Grid container>
            <Card>
                <Grid container direction='row' wrap='nowrap'>
                    <ModalInput value={priceByDate.beforeSeason} onChange={handleSeasonDateChange('beforeSeason')}/>
                    <ModalInput value={priceByDate.season} onChange={handleSeasonDateChange('season')}/>
                    <ModalInput value={priceByDate.afterSeason} onChange={handleSeasonDateChange('afterSeason')}/>
                </Grid>
                <Grid container direction='row' wrap='nowrap' justify='space-evenly' alignItems='center'>
                    <Grid container direction='column'>
                        <ModalInput value={priceList.outSeason.text} onChange={handleOutSeasonChange('outSeasonText')}/>
                        <ModalInput value={priceList.outSeason.price} onChange={handleOutSeasonChange('outSeasonPrice')}/>
                    </Grid>
                    <Grid container direction='column'>
                        <ModalInput value={priceList.season.text} onChange={handleOutSeasonChange('seasonText')}/>
                        <ModalInput value={priceList.season.price} onChange={handleOutSeasonChange('seasonPrice')}/>
                    </Grid>
                </Grid>
                <Grid container direction='column'>
                    <Typography color='textSecondary'>
                        Informace
                    </Typography>
                    <ModalInput value={infoText.lineOne} multiline onChange={handleInfoTextChange('lineOne')}/>
                    <ModalInput value={infoText.lineTwo} multiline onChange={handleInfoTextChange('lineTwo')}/>
                    <ModalInput value={infoText.footerLine} multiline onChange={handleInfoTextChange('footerLine')}/>
                </Grid>
                <Button 
                    variant='contained' 
                    color='primary'
                    style={{ margin: '25px 0px'}}
                    onClick={() => onSubmit()}
                >
                    Uložit
                </Button>
            </Card>
        </Grid>
    )
}

export default EditPriceModal;